module.exports = __webpack_public_path__ + "img/loading.d9b3828f.gif";